import { CookieOptions } from 'ngx-cookie';

export class CookiesOptions implements CookieOptions {}
